import { apiGet, apiPost } from '../../../adapters/api-client/api';
import { CourseSchedule } from '../domain/catalog';
import { LearnerRequestView } from './learner-explore';

/** What was asked for, as it stood when it was asked (DEC-S2-S06-06). */
export interface LearnerRequestContext {
  courseTitle: string;
  teacherName?: string;
  gradeLevel: string[];
  scheduleType?: string;
  schedule?: CourseSchedule;
  durationMode?: string;
  durationWeeks?: number;
  duration?: number;
  price?: number;
  currency?: string;
  /** The meeting asked for, when one was. */
  session?: { startsAt: string; endsAt: string; timezone: string };
}

/** The Student's model, the same states and values, plus what deciding needs. */
export interface ParentLearnerRequest extends LearnerRequestView {
  householdId: string;
  learnerFirstName?: string;
  context: LearnerRequestContext;
  decidable: boolean;
}

export function getParentLearnerRequests(): Promise<{ requests: ParentLearnerRequest[] }> {
  return apiGet('/api/v1/parent/learner-requests');
}

export function getParentLearnerRequest(requestId: string): Promise<ParentLearnerRequest> {
  return apiGet(`/api/v1/parent/learner-requests/${encodeURIComponent(requestId)}`);
}

export function declineLearnerRequest(
  requestId: string,
  expectedVersion: number,
): Promise<ParentLearnerRequest> {
  return apiPost(`/api/v1/parent/learner-requests/${encodeURIComponent(requestId)}/decline`, {
    expectedVersion,
  });
}
